module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('transition-group', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    key: "brand",
    staticClass: "modal-mask flexContainer",
    attrs: {
      "id": "brand"
    }
  }, [_c('div', {
    attrs: {
      "id": "commentlist"
    }
  }, [_c('h2', {
    staticClass: "uppercase txtCenter commentTitle"
  }, [_vm._v("Comments (" + _vm._s(_vm.getComments.length) + ")")]), _vm._v(" "), _c('img', {
    staticClass: "cross abs pointer",
    attrs: {
      "src": require("../../assets/croix.png"),
      "width": "20",
      "height": "20",
      "alt": ""
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flexContainer fd-c"
  }, [_vm._l((_vm.getComments), function(n) {
    return _c('div', {
      staticClass: "commentaire"
    }, [_c('div', {
      staticClass: "flexContainer fd-r jc-sb"
    }, [_c('div', {
      staticClass: "userInfo"
    }, [_vm._v(_vm._s(n.createdUser.initial))]), _vm._v(" "), _c('div', {
      staticClass: "commentContent rel full"
    }, [_c('p', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(n.createdUser.firstname) + " " + _vm._s(n.createdUser.lastname))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(n.content))]), _vm._v(" "), _c('p', {
      staticClass: "abs date"
    }, [_vm._v(_vm._s(n.createdAt))])])])])
  }), _vm._v(" "), (_vm.getComments.length === 0) ? _c('h3', {
    staticClass: "uppercase txtCenter"
  }, [_vm._v(_vm._s(_vm.$t("modalComment.noComment")))]) : _vm._e()], 2)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07bbbc3e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/modalComment.vue
// module id = 2994
// module chunks = 0